import { render, staticRenderFns } from "./AttachmentsStorage.vue?vue&type=template&id=530aa771&"
import script from "./AttachmentsStorage.vue?vue&type=script&lang=js&"
export * from "./AttachmentsStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports